import { html } from "lit-element";
import { DrawSVGBaseModule } from "../../ModuleBase/svg-base-module";

export class DrawVdHor2Module extends DrawSVGBaseModule {
	constructor(canvas) {
		super(canvas);

		this.name = "vd-hor-2";
		this.icon = svg_vd_hor_2;
	}
}

window.customElements.define("inspx-draw-vd-hor-2-module", DrawVdHor2Module);

const svg_vd_hor_2 = html`
<svg width="60" height="30.000000000000007" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg">
 <g>
  <title>Layer 1</title>
  <rect stroke="#444444" id="svg_2" height="30" width="59.53787" fill="#ffffff" y="0" x="0"/>
  <rect fill="#aaa7a7" stroke="#444444" stroke-width="0" stroke-dasharray="null" stroke-linejoin="null" stroke-linecap="null" x="0.02746" y="0.43774" width="29.49994" height="29.23297" id="svg_5"/>
  <line stroke="#444444" id="svg_1" y2="0" x2="30" y1="30" x1="30" stroke-linecap="null" stroke-linejoin="null" stroke-dasharray="null" fill="none"/>
  <text stroke="#444444" transform="matrix(1.748146119803863,0,0,1,-3.435311616745808,0) " xml:space="preserve" text-anchor="middle" font-family="Sans-serif" font-size="24" id="svg_4" y="23.16476" x="19.07524" stroke-linecap="null" stroke-linejoin="null" stroke-dasharray="null" stroke-width="0" fill="#000000">VD</text>
 </g>
</svg>`;
